module.exports = __webpack_public_path__ + "static/media/email.88f93d41.svg";